import * as firebase from 'firebase'
import * as db from '../../db'
import store from '@/store'
import { EventBus } from '../../components/common/event-bus'

export default {
  state: {
    user: null,
    userData: {},
    authLoading: false,
    gError: null,
    saveCheck: false,
    customPackageUser:[],
    adminData: false,
    notes:null
  },
  getters: {
    user: state => state.user,
    userData: state => state.userData,
    termsTimestamp: state => state.termsTimestamp,
    saveCheckG: state => state.saveCheck,
    customPackageUser: state => state.customPackageUser,
    adminData:state => state.adminData,
    notes:state => state.notes
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload
    },
    setNotes(state, payload){
      state.notes = payload
    },
    setAdmin(state, payload){
      if(payload.systemAdmin === 'true' || payload.companyRole === 'admin')
       {
        state.adminData = true
       }
       else {
        state.adminData = false
       }

    },
    setSaveCheck(state, payload) {
      state.saveCheck = payload
    },
    setUserData(state, payload) {
      state.userData = payload
    },
    setCustomPackageUser(state, payload){
        state.customPackageUser = payload
    },
    setLoading(state, payload) {
      state.authLoading = payload
    },
    setError(state, payload) {
      state.gError = payload
    },
    clearError(state) {
      state.gError = null
    }
  },
  actions: {
    setNotesStore({commit},payload){
      console.log('sf',payload.notes)
      commit('setNotes', payload.notes)
    },
    userDataSet({commit},payload){
       let data = {
        id:payload.id,
        email:payload.email
       }
      commit('setUserData', payload)
      commit('setUser', data)
    },
    userDataFetch({commit}){
      let customPackage =[]
      db.users.onSnapshot(function(snapshot) {
        snapshot.forEach(doc => {
            customPackage.push(doc.data())
        })
          commit('setCustomPackageUser', customPackage)
      })
    },
    async updateUserData({ commit }, data) {
      // console.log("TCL: updateUserData -> userData", data)
      commit('setLoading', true)
      commit('clearError')
      console.log('data 404', data)
      let userData = {
        id: store.getters.user.id,
        address: data.address,
        address2: data.address2,
        city: data.city,
        firstName: data.firstName,
        lastName: data.lastName,
        phone: data.phone,
        state: data.state,
        zip: data.zip,
        email: data.email,
        notes: data.notes,
        photoUrl: data.photoUrl
      }
      db.users
        .doc(userData.id)
        .update(userData)
        .then(returnedData => {
          commit('setLoading', false)

          EventBus.$emit('user-data-saved', data.unit)
        })
        .catch(userRecordError => {
          commit('setError', userRecordError)
          console.log('caught user record error:', userRecordError)
        })
    },
    async userTranjectionalDataUpdate({ commit }, data) {
      // console.log("TCL: updateUserData -> userData", data)
      commit('setLoading', true)
      commit('clearError')
      console.log('data 404', data)
      let userData = {
        id: store.getters.user.id,
        address: data.address,
        address2: data.address2,
        city: data.city,
        firstName: data.firstName,
        lastName: data.lastName,
        phone: data.phone,
        state: data.state,
        zip: data.zip,
        email: data.email,
        notes: data.notes,
        photoUrl: data.photoUrl
      }
      commit('setUserData', userData)
      EventBus.$emit('user-data-saved', data.unit)

    },
    async updateProfileData({ commit }, data) {
      // console.log("TCL: updateUserData -> userData", data)
      commit('setLoading', true)
      commit('clearError')
      let userData = {
        id: store.getters.user.id,
        address: data.address,
        city: data.city,
        firstName: data.firstName,
        lastName: data.lastName,
        phone: data.phone,
        state: data.state,
        zip: data.zip
      }
      db.users
        .doc(userData.id)
        .update(userData)
        .then(returnedData => {
          commit('setLoading', false)
          commit('setUserData', userData)
          store.dispatch('common/setMessage', {
            text: 'Your information has been saved.',
            icon: 'info_outline',
            color: 'success'
          })
          return
        })
        .catch(userRecordError => {
          commit('setError', userRecordError)
          console.log('caught user record error:', userRecordError)
        })
    },
    async signUserUp({ commit, dispatch }, payload) {
      // // console.log("TCL: signUserUp -> at store action")
      commit('setLoading', true)
      commit('clearError')
      firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password)
        .then(user => {
          const newUser = {
            id: user.uid,
            email: user.email,
          }
          db.users
            .doc(user.uid)
            .set({
              email: user.email,
              termsTimestamp: store.getters['term/termsTimestamp'],
              photoUrl: user.photoURL || 'https://res.cloudinary.com/ioty/image/upload/f_auto/v1514505063/app/profileUrl.png'
            })
            .then(function () {
              commit('setUser', newUser)
              store.commit('common/SET_MENU', false)
              commit('setLoading', false)
            })
            .catch(userRecordError => {
              commit('setError', userRecordError)
              console.log('caught user record error:', userRecordError)
            })
        })
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log('caught signup:', error)
        })
      store.dispatch('common/setMessage', {
        text: 'Thanks for joining us. Your account has been created,',
        icon: 'info_outline',
        color: 'success'
      })
      return
    },
    saveSetCheck({ commit }) {
      commit('setSaveCheck', true)
    },
    saveSetCheckFalse({ commit }) {
      commit('setSaveCheck', false)
    },
    signUserIn({ commit, dispatch }, formData) {
      commit('setLoading', true)
      commit('clearError')
      firebase
        .auth()
        .signInWithEmailAndPassword(formData.email, formData.password)
        .then(user => {
          // console.log("TCL: signUserIn -> user", user)
          const newUser = {
            id: user.uid,
            email: user.email,
          }
          commit('setUser', newUser)
          commit('setAdmin', newUser)
          store.commit('common/SET_MENU', false)
          dispatch('getUserById', newUser.id)
          dispatch('common/setMessage', {
            text: 'You have signed in successfully',
            icon: 'info_outline',
            color: 'success'
          })
          commit('setLoading', false)
        })
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log('caught signin error:', error)
          dispatch('common/setMessage', {
            text: 'There is a problem with your signin',
            icon: 'error_outline',
            color: 'error'
          })
        })
      return
    },
    resetPassword({ commit, dispatch }, email) {
      commit('setLoading', true)
      firebase
        .auth()
        .sendPasswordResetEmail(email)
        .then(function () {
          commit('common/SET_MESSAGE', {
            text: 'An email has been sent to ' + email,
            icon: 'info_outline',
            color: 'success'
          })
          dispatch('common/showMessage')
          commit('setLoading', false)
        })
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log('caught signin error:', error)
          dispatch('common/setMessage', {
            text: 'There is a problem with your reset',
            icon: 'error_outline',
            color: 'error'
          })
        })
    },
    logout({ commit, dispatch }) {
      firebase.auth().signOut()

      dispatch('common/setMessage', {
        text: 'You have signed out successfully',
        icon: 'info_outline',
        color: 'success'
      })
      dispatch('floorplan/clearUserFloorplans')
      commit('setUser', null)
      commit('setUserData', null)
      commit('setAdmin', false)
      commit('setLoading', false)
    },
    getUserById({ commit, dispatch }, id) {
      commit('setLoading', true)

      db.users
        .doc(id)
        .get()
        .then(function (userData) {
          // console.log("TCL: getUserById -> userData", userData.data())
          commit('setUserData', userData.data())
          commit('setAdmin',  userData.data())
        })
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log('caught get user error:', error)
          dispatch('common/setMessage', {
            text: 'There is a problem with the user account',
            icon: 'error_outline',
            color: 'error'
          })
        })
    },
    userIsAdmin() {
      // Get user user from firebase
      // Checking if there is a user in the store (logged in) and checking if there is anything in the user's admin document.

      return new Promise(resolve => {
        let docRef = db.users.doc(store.getters.user.id)
        docRef.get().then(function (doc) {
          // console.log("TCL: userIsAdmin -> doc", doc)
          if (doc) {
            // console.log("TCL: docRef.get -> isAdmin", doc)
            resolve({ isAdmin: true })
          } else {
            // console.log("TCL: docRef.get -> isNOTAdmin", doc)
            resolve({ isAdmin: false })
          }
        })
      })

    },
    autoSignIn({ commit, dispatch }) {
      firebase.auth().onAuthStateChanged((user) => {

        if (user) {
          commit('setLoading', true)
          db.users
            .doc(user.uid)
            .get()
            .then ((userData)=> {
              // console.log("TCL: getUserById -> userData", userData.data())
              commit('setUserData', userData.data())
              commit('setAdmin',  userData.data())

              commit('setUser',{
                id:user.uid,
                email:user.email
              })
            })
            .catch(error => {
              commit('setLoading', false)
              commit('setError', error)
              console.log('caught get user error:', error)
              dispatch('common/setMessage', {
                text: 'There is a problem with the user account',
                icon: 'error_outline',
                color: 'error'
              })
            })

        }
      });
    },
    userIsAuthenticated() {
      return store.getters.user != null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js